import React from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { CreditHistorySummaryItem } from "../CreditHistorySummaryItem";
import { useCreditHistorySummary } from "./hooks";
import styles from "./styles.module.scss";

interface CreditHistorySummaryProps {
  className?: string;
  children?: React.ReactNode;
  maxItemsToDisplay?: number;
}

export const CreditHistorySummary: React.FC<CreditHistorySummaryProps> = ({
  className,
  children,
  maxItemsToDisplay = Infinity,
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "CreditHistorySummary");
  const {
    context: { totalCredits, transactions },
  } = useCreditHistorySummary();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("overview-container")}>
        <span className={cn("title")}>
          {t("wallet.credits.transaction.title")}
        </span>
        <span className={cn("balance")}>{totalCredits}</span>
        {/* We don't have proper message to show, hiding it now */}
        {/* <span className={cn("subtitle")}>
          {t("wallet.credits.transaction.subtitle")}
        </span> */}
      </div>

      <div className={cn("history-container")}>
        <span className={cn("history-title")}>
          {t("wallet.credits.transaction.transactionHistory")}
        </span>

        {transactions?.map((transaction, index) => {
          if (maxItemsToDisplay && index < maxItemsToDisplay) {
            return <CreditHistorySummaryItem {...transaction} />;
          }
          return null;
        })}

        {children}
      </div>
    </div>
  );
};
